import { createAuthService } from "@playsafely/auth-client";
import { Auth } from "aws-amplify";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { PLATFORM_HOST } from "../../settings/setting";
import { hideProgress, showProgress } from "../eventAction/progress.service";

const authService = createAuthService({
  mode: process.env.REACT_APP_AUTH_MODE,
  baseUrl: `${PLATFORM_HOST.replace(/\/$/, "")}/api/auth`,
  cognito: {
    sdk: Auth,
    signInGoogle: () => Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google }),
    progress: { show: showProgress, hide: hideProgress },
  },
});

export default authService;
export { mapUserInfo } from "@playsafely/auth-client";
// Provider methods are bound, so existing named imports remain safe callbacks.
export const {
  getToken,
  autoLogIn,
  signUp,
  signIn,
  signInGoogle,
  verification,
  resend_verification,
  signOut,
  forgotPassword,
  forgotPasswordSubmit,
  changePassword,
  newPassword,
  verifyResetCode,
  completePasswordReset,
  setAccountStatus
} = authService;
